import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ViewVoucherComponent } from "@root/component/view-voucher/view-voucher.component";
import { TranslateService } from "@root/shared/service/translate.service";
import { NzModalService } from "ng-zorro-antd/modal";

@Component({
  selector: "v4-common-task-list",
  templateUrl: "./task.component.html",
  styleUrls: ["./task.component.scss"],
})
export class V4CommonTaskListComponent implements OnInit {
  @Input() listOfTask = [];
  @Input() total = 0;
  @Input() page = 1;
  @Input() pageSize = 20;
  @Output() onClickTask = new EventEmitter();
  @Output() onPageChange = new EventEmitter();

  readonly statusColorMap = {
    0: "#3EC76E",
    1: "#FB4365",
    2: "#0E5EFF",
  };
  constructor(
    private t: TranslateService,
    private modal: NzModalService,
  ) {}

  ngOnInit() {}

  getType(type) {
    return this.t.t(`task.word.type.type_${type}`);
  }

  getStatus(status) {
    return status === 0
      ? this.t.t("task.list.pending")
      : status === 1
        ? this.t.t("task.list.ongoing")
        : this.t.t("task.list.completed");
  }

  showCredentials(data) {
    if (data.length === 0) {
      return;
    }
    const list = data.map((info) => info.large_url);
    this.modal.create({
      nzTitle: this.t.t("word.credentials"),
      nzWidth: 715,
      nzFooter: null,
      nzContent: ViewVoucherComponent,
      nzComponentParams: {
        pictureList: list,
      },
    });
  }

  // onPageChange (page) {

  // }
}
